import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import { Stack } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Link } from "@mui/material";
import { useSelector } from "react-redux";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Avatar from "@mui/material/Avatar";

import CartModal from "./CartModal";

import settings from "../config.json";

const { title, linkToME, bookLinkTooltipText } = settings;

const theme = createTheme({
  palette: {
    neutral: {
      main: "#fff",
      contrastText: "#fff",
    },
  },
});

export default function ButtonAppBar() {
  const idsOfItemsInCart = useSelector((state) => state.idsOfItemsInCart);
  const numItemsInCart = idsOfItemsInCart.length;
  let message = "";
  if (numItemsInCart === 1) {
    message = "1 item in cart";
  } else {
    message = `${numItemsInCart} items in cart`;
  }
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}
          >
            <Avatar
              alt={title}
              src="./assets/logo.png"
              sx={{ mr: 1 }}
              variant="square"
            />
            <Link href="./index.html" color="inherit" underline="hover">
              {title}
            </Link>
          </Typography>

          <Box>
            <Stack
              spacing={2}
              direction="row"
              sx={{
                display: {
                  xs: "none",
                  md: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                },
              }}
            >
              <Typography>{message}</Typography>
              <CartModal></CartModal>
              <Link
                color="inherit"
                href={linkToME}
                target="_blank"
                rel="noreferrer"
              >
                <ThemeProvider theme={theme}>
                  <Tooltip title={bookLinkTooltipText}>
                    <IconButton color="neutral">
                      <MenuBookIcon></MenuBookIcon>
                    </IconButton>
                  </Tooltip>
                </ThemeProvider>
              </Link>
            </Stack>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
